<template>
<div style="margin: 10px" class="container-fluid">
    <div class="row">
        <!-----------------------------------------------------------------------------------------------MODAL EDIT------------------------->
        <b-modal ref="service-modal" hide-footer hide-header title="Edit Service">
            <div style="padding: 0">
                <div style="margin: 10px 0">
                    <h4 class="service_txt">Edit Service</h4>
                </div>
                <hr>
                <form data-parsley-validate novalidate @submit.prevent>
                    <div class="">
                        <label class="label_add" for="userName">Service Name</label>
                        <input type="text" n parsley-trigger="change" required placeholder="Enter service name" class="input_add" v-model="selectedRows.serviceName">
                    </div>
                    <div style="margin-top: 20px; margin-bottom: 20px" class="">
                        <label class="label_add" for="userName">Service Description</label>
                        <textarea type="text" parsley-trigger="change" required placeholder="Enter service description" class="input_add2" v-model="selectedRows.serviceDescription"></textarea>
                    </div>
                    <div style="text-align: right;">
                        <button class="btn_add" type="submit" @click="editServices(selectedRows.serviceId)">
                            Edit Service
                        </button>
                    </div>
                </form>
            </div>
        </b-modal>
        <!-----------------------------------------------------------------------------------------------MODAL EDIT ends-------------------------->
        <!-----------------------------------------------------------------------------------------------MODAL DELETE------------------------->
        <b-modal ref="service-modal-delete" hide-footer hide-header title="Edit Service">
            <div style="padding: 0">
                <div style="margin: 10px 0">
                    <h4 class="service_txt">Delete Service</h4>
                </div>
                <hr>
                <form data-parsley-validate novalidate @submit.prevent>
                    <div class="">
                        <label class="label_add" for="userName">Service Name</label>
                        <input type="text" n parsley-trigger="change" readonly required placeholder="Enter service name" class="input_add" v-model="selectedRows.serviceName">
                    </div>
                    <div style="margin-top: 20px; margin-bottom: 20px" class="">
                        <label class="label_add" for="userName">Service Description</label>
                        <textarea type="text" parsley-trigger="change" readonly required placeholder="Enter service description" class="input_add2" v-model="selectedRows.serviceDescription"></textarea>
                    </div>
                    <div style="text-align: right;">
                        <button class="btn_add" type="submit" @click="deleteservice(selectedRows.serviceId)">
                            Delete Service
                        </button>
                    </div>
                </form>
            </div>
        </b-modal>
        <!-----------------------------------------------------------------------------------------------MODAL DELETE ends-------------------------->
        <div class="container">
            <div class="row">
                <h4 class="service_txt mt-0 mb-3">Services</h4>
                <div class="col-lg-5">
                    <div class="document_div">
                        <h4 class="txt_add mb-3">Add Service</h4>
                        <div class="">
                            <form action="#" data-parsley-validate novalidate @submit.prevent>
                                <div class="">
                                    <label class="label_add" for="userName">Service Name</label>
                                    <input type="text" n parsley-trigger="change" required placeholder="Enter service name" class="input_add" v-model="newserviceName">
                                </div>
                                <div style="margin-top: 20px" class="">
                                    <label class="label_add" for="userName">Service Description</label>
                                    <textarea class="input_add2" type="text" parsley-trigger="change" required placeholder="Enter service description" v-model="newserviceDescription"></textarea>
                                </div>
                                <div style="margin-top: 20px; text-align: right">
                                    <button class="btn_add" type="submit" @click="addServices()">
                                        Add Service
                                    </button>
                                </div>
                            </form>
                        </div>
                        <!-- end col -->
                    </div>
                </div>
                <!-- end col -->

                <!-----------------------------------------------------------------------------------------------ITEM CREATE ENDS-------------------------->
                <div style="margin: 0;" class="col-lg-7">
                    <div v-if="rows.length" class="table_add">
                        <h4 style="margin-left: 40px" class="txt_add mb-3">List of Services</h4>
                        <vue-bootstrap4-table :rows="rows" :columns="columns" :config="config">
                            <template slot="empty-results">
                                No uploads found
                            </template>
                            <template slot="id" slot-scope="props">
                                <span>
                                    {{props.row.vbt_id}}
                                </span>
                            </template>
                            <template slot="stateName" slot-scope="props">
                                <span>
                                    {{props.cell_value}}
                                </span>
                            </template>
                            <template slot="stateCode" slot-scope="props">
                                <span>
                                    {{props.cell_value}}
                                </span>
                            </template>
                            <template slot="action" slot-scope="props">
                                <!-- <span>
                                    <a @click="editItem(props.row)" class="btn btn-primary btn-xs" style="font-size:10px; color:#fff;">Edit</a>
                                </span> -->
                                <b-button class="btn_edit" @click="editItem(props.row)" id="show-btn">Setting</b-button>
                                <b-button class="btn_edit2" @click="deleteItem(props.row)" id="show-btn">Delete</b-button>
                            </template>
                        </vue-bootstrap4-table>
                    </div>
                </div>
            </div>
        </div>
        <!-- end col -->
    </div>
</div>
</template>

<script>
import Swal from 'sweetalert2'
// @ is an alias to /src

///////// IMPORT COOKIE SERVICE
import cookieOps from "@/services/cookieOps.js";
/////////////////////////
import router from '@/router/index'
///////// IMPORT COOKIE SERVICE

import VueBootstrap4Table from 'vue-bootstrap4-table'

import httpRequest from "@/services/httpRequests.js";
export default {
    name: 'services',
    components: {
        VueBootstrap4Table
    },
    data() {
        return {
            selectedRows: [],
            newserviceName: '',
            newserviceDescription: '',
            columns: [{
                    label: "S/N",
                    name: "id",
                    slot_name: "id"
                },
                {
                    label: "Service Name",
                    name: "serviceName",
                    //   slot_name: "stateName",
                    sort: false,
                },
                {
                    label: "Service Id",
                    name: "serviceId",
                    sort: false,
                },
                {
                    label: "Action",
                    name: "id",
                    slot_name: "action",
                }
            ],
            newbuild: [],
            rows: [],
            config: {
                card_mode: false,
                show_refresh_button: false,
                show_reset_button: false,
                checkbox_rows: false,
                rows_selectable: false,
                selected_rows_info: false,
                card_title: "List of Documents",
                global_search: {
                    placeholder: "Search Documents",
                    visibility: false,
                    case_sensitive: false,
                },
                pagination: true, // default true
                pagination_info: false, // default true
                num_of_visibile_pagination_buttons: 7, // default 5
                per_page: 5, // default 10
                per_page_options: [5, 10, 20, 30],
            },
        };
    },

    hideModal() {},

    beforeRouteEnter(to, from, next) {
        const fetch = httpRequest.get('services/all').then(function (res) {
            next(vm => vm.setData(res))
        })
    },
    computed: {
        userLastCount() {
            return this.rows[this.rows.length - 1].a;
        }
    },

    mounted() {
        console.log(this.selectedRows)
    },
    /// SCOPE METHODS
    methods: {
        editItem(cell_value) {
            // console.log(cell_value);
            this.$refs['service-modal'].show()
            this.selectedRows = cell_value
        },
        deleteItem(cell_value) {
            // console.log(cell_value);
            this.$refs['service-modal-delete'].show()
            this.selectedRows = cell_value
        },
        setData(data) {
            let allservices = httpRequest.detokenizeData(data.data.dataToken)
            console.log(allservices);
            this.rows = allservices.data
        },
        //////// sweet allert serivice
        alertDisplay(w, x, y) {
            // $swal function calls SweetAlert into the application with the specified configuration.
            this.$swal(w, x, y);
        },
        addServices() {
            let thiss = this
            const createItem = httpRequest.post('services/create', {
                'serviceName': this.newserviceName,
                'serviceDescription': this.newserviceDescription
            }).then(function (res) {
                if (res.data.code == 's200') {
                    thiss.newbuild.serviceName = thiss.newserviceName;
                    thiss.newbuild.itemId = '20000';
                    thiss.newbuild.deletedStatus = '0';
                    thiss.newbuild.slug = thiss.newitemName;
                    thiss.newbuild.suspendStatus = '0';
                    thiss.rows.push(thiss.newbuild)
                    console.log(userLastCount());
                    thiss.alertDisplay('Service Created', res.data.message, 'success');
                } else {
                    thiss.alertDisplay('Service Not Created', res.data.message, 'error');
                }
            })
        },
        // DELETE SERVICE
        // deleteservice() {
        //     const serviceId = this.selectedRows.serviceId;
        //     const fetch = httpRequest.put(`services/delete/:serviceId`).then(function (res) {
        //         console.log(res)
        //     })
        // },

        deleteservice() {
            let thiss = this
            const serviceId = this.selectedRows.serviceId;
            const deleteService = httpRequest.put(`services/delete/${serviceId}`, {}).then(function (res) {
                console.log('RESPONSE', res)
                if (res.data.code == 's200') {
                    thiss.alertDisplay('Service Deleted', res.data.message, 'success');
                } else {
                    thiss.alertDisplay('Service Not Deleted', res.data.message, 'error');
                }
            })
            this.$refs['service-modal-delete'].hide();
        },

        // EDIT SERVICE

        editServices() {
            const serviceId = this.selectedRows.serviceId;
            const editItem = httpRequest.put(`services/edit/${serviceId}`, {
                'serviceName': this.selectedRows.serviceName,
                'serviceDescription': this.selectedRows.serviceDescription
            }).then(function (res) {
                console.log('RESPONSE', res)
                if (res.data.code == 's200') {
                    this.newbuild.serviceName = this.selectedRows.serviceName;
                    this.newbuild.serviceDescription = this.selectedRows.serviceDescription;
                    console.log('Edited');
                    this.newbuild.itemId = '20000';
                    this.newbuild.deletedStatus = '0';
                    this.newbuild.slug = this.newitemName;
                    this.newbuild.suspendStatus = '0';
                    this.rows.push(thiss.newbuild)
                    console.log(userLastCount());
                    this.alertDisplay('Service Edited', res.data.message, 'success');
                } else {
                    this.alertDisplay('Service Not Edited', res.data.message, 'error');
                }
            })
            this.$refs['service-modal'].hide();
        }
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

.service_txt {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 27px;
    display: flex;
    align-items: center;
    color: #494949;
}

a {
    text-decoration: none;
}

.btn_edit {
    width: auto;
    height: auto;
    padding: 10px;
    background: #E9F0FF;
    margin: 5px 5px;
    border: none;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #1A87CA;
}

.btn_edit2 {
    width: auto;
    height: auto;
    padding: 10px;
    background: #ab3b48;
    margin: 5px 5px;
    border: none;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #E9F0FF;
}

.btn_edit:hover {
    width: auto;
    height: auto;
    padding: 10px;
    background: #E9F0FF;
    margin: 5px 0;
    cursor: pointer;
    border: none;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #1A87CA;
}

.btn_add {
    /* padding: 20px; */
    border: none;
    width: 150px;
    height: 50px;
    background: #555A6E;
    border-radius: 4px;

    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #FFFFFF;

}

.txt_add {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 27px;
    display: flex;
    align-items: center;
    color: #494949;
}

template {
    position: relative;
    min-height: 100%;
}

.card-header {
    font-weight: 600 !important;
    background-color: red;
}

body {
    padding-bottom: 60px;
    overflow-x: hidden;
}

.authentication-bg.enlarged {
    min-height: 100px;
}

.document_div {
    width: 100%;
    height: 407px;
    background: #FFFFFF;
    border-radius: 10px;
    padding: 20px 40px;
}

.document_div2 {
    width: 100%;
    height: auto;
    background: #FFFFFF;
    border-radius: 10px;
    padding: 20px 10px;
}

body.authentication-bg {
    background-image: url(../../assets/bg-light-img.jpg);
    background-size: cover;
    background-position: center;
}

.input_add {
    padding: 20px;
    width: 100%;
    height: 55px;

    background: #FFFFFF;
    border: 0.5px solid #D3D8DD;
    box-sizing: border-box;
    border-radius: 4px;
}

.table_add {
    width: 100%;
    height: auto;
    padding: 20px 0;
    background: #FFFFFF;
    border-radius: 4px;
}

.input_add2 {
    padding: 20px;
    width: 100%;
    height: 87px;
    background: #FFFFFF;
    border: 0.5px solid #D3D8DD;
    box-sizing: border-box;
    border-radius: 4px;
}

.label_add {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 115.5%;
    display: flex;
    align-items: center;
    color: #494949;
    margin-bottom: 10px;
}
</style>
